var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmailIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.25 4.375L6.35307 7.94715C6.76631 8.23641 6.97292 8.38105 7.19766 8.43707C7.39618 8.48655 7.60382 8.48655 7.80234 8.43707C8.02708 8.38105 8.23369 8.23641 8.64692 7.94715L13.75 4.375M4.25 12.5H10.75C11.8001 12.5 12.3251 12.5 12.7262 12.2956C13.079 12.1159 13.3659 11.829 13.5456 11.4762C13.75 11.0751 13.75 10.5501 13.75 9.5V5.5C13.75 4.4499 13.75 3.92485 13.5456 3.52377C13.3659 3.17096 13.079 2.88413 12.7262 2.70436C12.3251 2.5 11.8001 2.5 10.75 2.5H4.25C3.1999 2.5 2.67485 2.5 2.27377 2.70436C1.92096 2.88413 1.63413 3.17096 1.45436 3.52377C1.25 3.92485 1.25 4.4499 1.25 5.5V9.5C1.25 10.5501 1.25 11.0751 1.45436 11.4762C1.63413 11.829 1.92096 12.1159 2.27377 12.2956C2.67485 12.5 3.1999 12.5 4.25 12.5Z",
    stroke: "#898F9D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/email-icon.b14a69b081e2e6053581f0707b16d9ea.svg";
export { ForwardRef as ReactComponent };